import { Card } from "antd";
import { ContainerFallback, MessageFallback } from "./styles";

export default function Fallback() {
  const { Meta } = Card;

  return (
    <ContainerFallback>
      <MessageFallback>Em desenvolvimento!</MessageFallback>
    </ContainerFallback>
  );
}
